module.exports = __webpack_public_path__ + "img/4_38.d4b4d8ea.png";